import { type PropsWithChildren } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

/**
 * Props for the SelectV2GroupLabel component.
 * @public
 */
export type SelectV2GroupLabelProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId;

/**
 * `SelectV2.GroupLabel` defines the label of an option group. The component
 * is only valid within a `SelectV2.Group`.
 *
 * @example
 * ```tsx
 * <SelectV2.Group>
 *   <SelectV2.GroupLabel>Colors</SelectV2.GroupLabel>
 *   <SelectV2.Option value="red">Red</SelectV2.Option>
 *   <SelectV2.Option value="green">Green</SelectV2.Option>
 * </SelectV2.Group>
 * ```
 * @public
 */
export function SelectV2GroupLabel(props: SelectV2GroupLabelProps) {
  return null;
}

/**
 * Props for the SelectV2Group component
 * @public
 */
export type SelectV2GroupProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId;

/**
 * `SelectV2.Group` defines a group of options that share some commonalities.
 * The component is only valid within a `SelectV2.Content` element.
 *
 * @example
 * ```tsx
 * <SelectV2.Content>
 *   <SelectV2.Group>
 *     <SelectV2.GroupLabel>Colors</SelectV2.GroupLabel>
 *     <SelectV2.Option value="red">Red</SelectV2.Option>
 *     <SelectV2.Option value="green">Green</SelectV2.Option>
 *   </SelectV2.Group>
 * </SelectV2.Content>
 * ```
 * @public
 */
export function SelectV2Group(props: SelectV2GroupProps): null {
  return null;
}
